export class Address {
    constructor(element) {
        this.wrapper = $(element);

        this.setElementClasses();

        this.type = $('.' + this.TYPE_CLASS);
        this.switcher = $('.' + this.SWITCHER_CLASS);
        this.textBlock = $('.' + this.TEXT_CLASS);

        $('.' + this.SELECT_CLASS).on('loaded.bs.select', () => {
            this.selectBlock = $('.' + this.SELECT_CLASS + '.bootstrap-select');

            this.switcher.off('click').on('click', (event) => this.switchBlocks.call(this, event));

            if (this.textBlock.val()) {
                this.switcher.trigger('click');
            }
        });

        this.textBlock.on('keyup', () => {
            setTimeout(() => this.changeInput(), 200);
        });
    }

    setElementClasses() {
        this.SELECT_CLASS = 'js-order-address_select';
        this.TEXT_CLASS = 'js-order-address_text';
        this.SWITCHER_CLASS = 'js-order-address_switcher';
        this.TYPE_CLASS = 'js-order-address_type';
        this.STREET_INPUT_CLASS = 'js-order-address_street';
    }

    switchBlocks(event) {
        event.preventDefault();

        let oldType = this.type.val(),
            oldSwitcherText = this.switcher.text();

        this.type.val(this.type.data('toggle'));
        this.type.data('toggle', oldType);

        this.switcher.text(this.switcher.data('toggle'));
        this.switcher.data('toggle', oldSwitcherText);

        if (this.type.val() === 'select') {
            this.textBlock.hide();
            this.selectBlock.show();
        } else {
            this.textBlock.show();
            this.selectBlock.hide();
        }
    }

    changeInput() {
        this.textBlock.autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: '/ajax/location/search_address/',
                    data: {
                        city: $('.js-city').val(),
                        query: request.term
                    },
                    dataType: "json",
                    success: (data) => response(data),
                    error: () => response([]),
                });
            },
            minLength: 2,
        });
    }
}
